const sleep = (time) => new Promise((response) => setTimeout(response, time));

export default sleep;
